import type { TFunction } from 'i18next';

type DatosMensaje = {
  /** Nombre de quien invita (el de su cuenta; puede venir vacío). */
  de: string;
  presupuesto: string;
  enlace: string;
};

export type MensajeInvitacion = { asunto: string; texto: string };

/**
 * El mensaje que viaja con el enlace «A bordo» (WhatsApp, correo o lo que
 * elija quien invita): es lo primero que lee la persona invitada. Cuenta lo
 * mismo que la pantalla de bienvenida (quién invita y a qué barco). Texto
 * plano: saludo, el enlace solo en su línea y qué pasa al abrirlo.
 */
export function mensajeInvitacion(
  t: TFunction,
  { de, presupuesto, enlace }: DatosMensaje,
): MensajeInvitacion {
  const nombre = de.trim();
  if (!nombre) {
    return {
      asunto: t('You are invited aboard «{{budget}}»', { budget: presupuesto }),
      texto: t(
        'Hi! You are invited to come aboard «{{budget}}», a budget in Rumbo.\n{{link}}\nOpen it and sign in with your Google account: you will land straight in that budget. The link works for 7 days and for one person only.',
        { budget: presupuesto, link: enlace },
      ),
    };
  }
  return {
    asunto: t('{{name}} invites you aboard «{{budget}}»', {
      name: nombre,
      budget: presupuesto,
    }),
    texto: t(
      'Hi! {{name}} invites you to come aboard «{{budget}}», their budget in Rumbo.\n{{link}}\nOpen it and sign in with your Google account: you will land straight in that budget. The link works for 7 days and for one person only.',
      { name: nombre, budget: presupuesto, link: enlace },
    ),
  };
}

/** `mailto:` con asunto y cuerpo rellenos (para el PC, sin hoja de compartir). */
export function enlaceCorreo({ asunto, texto }: MensajeInvitacion): string {
  return `mailto:?subject=${encodeURIComponent(asunto)}&body=${encodeURIComponent(texto)}`;
}
